import { render, staticRenderFns } from "./PendingEditRequestItem.vue?vue&type=template&id=66e19d92&"
import script from "./PendingEditRequestItem.vue?vue&type=script&lang=js&"
export * from "./PendingEditRequestItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports